export type Vars = Record<string, string>

export const VAR_KEYS = [
  '--cor-primaria',
  '--cor-primaria-hover',
  '--cor-secundaria',

  '--cor-texto-primario',
  '--cor-texto-secundario',
  '--cor-texto-link',
  '--cor-fundo-principal',
  '--cor-fundo-secundario',
  '--cor-borda',
  '--cor-fundo-hover',
  '--cor-scrollbar',

  '--cor-sucesso',
  '--cor-perigo',
  '--cor-aviso',
  '--cor-info',

  '--tabela-zebra-even',
  '--tabela-zebra-odd',
  '--tabela-row-hover-bg',

  '--row-selected-mix',
  '--row-selected-mix-hover',
] as const

export function readLibVars(keys = VAR_KEYS as readonly string[]): Vars {
  const root = document.documentElement
  const styles = getComputedStyle(root)
  const out: Vars = {}
  keys.forEach((k) => (out[k] = (styles.getPropertyValue(k) || '').trim()))
  return out
}

export function applyOverrides(overrides: Vars) {
  const root = document.documentElement
  Object.entries(overrides).forEach(([k, v]) => {
    if (v) root.style.setProperty(k, v, 'important')
  })
}

export function clearOverrides(keys = VAR_KEYS as readonly string[]) {
  const root = document.documentElement
  keys.forEach((k) => root.style.removeProperty(k))
}

export function mergeEffective(base: Vars, overrides?: Vars): Vars {
  return { ...base, ...(overrides || {}) }
}

export function minimalDarkOverrides(base: Vars): Vars {
  return {
    '--cor-primaria': base['--cor-primaria'] || '#262b41',
    '--cor-secundaria': base['--cor-secundaria'] || '#e73d3e',

    '--cor-texto-primario': '#ffffff',
    '--cor-texto-secundario': base['--cor-texto-secundario'] || '#bcbcbc',
    '--cor-texto-link': base['--cor-texto-link'] || '#8ab4ff',
    '--cor-fundo-principal': '#1a1c23',
    '--cor-fundo-secundario': '#2a2f3a',
    '--cor-borda': '#3d4250',
    '--cor-fundo-hover': '#2a3a48',
    '--cor-scrollbar': '#666',
  }
}

export interface ZebraFixed { odd: string; even: string; hover: string }

const DEFAULT_ZEBRA: Record<'light' | 'dark', ZebraFixed> = {
  light: {
    odd: '#f7f9fc',
    even: '#eef2f7',
    hover: '#e6f4ff',
  },
  dark: {
    odd: '#1f2430',
    even: '#252b39',
    hover: '#344156',
  },
}

export function applyFixedZebra(
  theme: 'light' | 'dark',
  overrides?: Partial<ZebraFixed>,
  rowSelectedMix = 0.22,
  rowSelectedMixHover = 0.32
) {
  const base = DEFAULT_ZEBRA[theme]
  const z: ZebraFixed = {
    odd: overrides?.odd ?? base.odd,
    even: overrides?.even ?? base.even,
    hover: overrides?.hover ?? base.hover,
  }

  const vars: Vars = {
    '--tabela-zebra-odd': z.odd,
    '--tabela-zebra-even': z.even,
    '--tabela-row-hover-bg': z.hover,
    '--row-selected-mix': `${Math.round(rowSelectedMix * 100)}%`,
    '--row-selected-mix-hover': `${Math.round(rowSelectedMixHover * 100)}%`,
  }

  applyOverrides(vars)
}
